import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import styled from "styled-components";

const SortByDropdownWrapper = styled.div`
  position: relative;
  .header {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    -webkit-tap-highlight-color: transparent !important;
    &:focus,
    &:visited,
    &:active {
      outline: none !important;
    }
    @media (max-width: 992px) {
      display: flex;
      justify-content: flex-end;
    }
  }
  .body {
    position: absolute;
    top: 100%;
    left: 0;
    background: white;
    width: 100%;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }
  .value {
    padding: 5px 5px;
    border-bottom: 1px solid #f1f1f1;
    cursor: pointer;
    &:hover {
      background: #f1f1f1;
    }
  }
  .value:first-of-type {
    padding-top: none;
  }
  .value:last-of-type {
    padding-bottom: 3px;
    border-bottom: none;
  }
`;

const SortByDropdown = ({ selected, sortByHandler }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = (value) => {
    setIsOpen(!isOpen);
    if (value !== null) {
      value === selected ? sortByHandler(null) : sortByHandler(value);
    }
  };
  return (
    <SortByDropdownWrapper>
      <div className="header" onClick={() => toggleOpen(null)}>
        <p>{selected === null ? "SORT BY" : selected}</p>
        {isOpen ? <FaChevronUp /> : <FaChevronDown />}
      </div>
      {isOpen ? (
        <div className="body">
          <div className="value" onClick={() => toggleOpen("Title (A-Z)")}>
            Title (A-Z)
          </div>
          <div className="value" onClick={() => toggleOpen("Title (Z-A)")}>
            Title (Z-A)
          </div>
        </div>
      ) : null}
    </SortByDropdownWrapper>
  );
};

export default SortByDropdown;
